<template>
    <div
        ref="modal"
        class="modal warning-modal"
        data-backdrop="static"
        tabindex="-1"
        role="dialog"
        aria-labelledby="addStaffsToDepartmentModal-title"
        aria-modal="true"
        hidden
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button class="close" data-dismiss="modal" aria-label="Close Modal" @click.prevent="closeAllModal()">
                        <i class="fa-solid fa-xmark" aria-hidden="true" />
                    </button>

                    <h2 id="addStaffsToDepartmentModal-title" class="modal-title">Confirmation</h2>
                </div>
                <div class="modal-body textAlignCenter">
                    <img src="/img/warning.png" class="warning-icon" alt="" role="presentation" />

                    <h2 class="marginTop40">Adding Staffs To</h2>
                    <h3 class="fw-normal">
                        {{ departmentMeta.settings?.level1?.singular ? departmentMeta.settings?.level1?.singular : 'Department' }}:
                        <b>{{ values.department?.name }} </b>
                    </h3>
                    <h3 class="fw-normal" v-if="values.school != null">
                        {{ departmentMeta.settings?.level2?.singular ? departmentMeta.settings?.level2?.singular : 'School' }}: <b>{{ values.school?.name }}</b>
                    </h3>

                    <div class="collapsingQuestion">
                        <button
                            class="btn"
                            :data-target="'#view-list-of-selected-staffs'"
                            data-toggle="collapse"
                            aria-expanded="false"
                            :aria-controls="'view-list-of-selected-staffs'"
                        >
                            View List of Selected Staffs
                        </button>
                        <div :id="'view-list-of-selected-staffs'" class="collapse padding20 position-relative">
                            <table class="table">
                                <caption>
                                    List of ({{
                                        staffsSelected.length
                                    }}) selected staffs
                                </caption>
                                <thead>
                                    <tr>
                                        <th class="width78px minWidth78px maxWidth78px">Index</th>
                                        <th>Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(staff, idx) in staffsSelected">
                                        <td class="textAlignRight">
                                            {{ idx + 1 }}
                                        </td>
                                        <td class="textAlignLeft">{{ staff.name }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <p class="col-xs-12 col-md-8 col-md-offset-2 marginTop20">
                        Once confirmed, staff members will be assigned to their respective
                        <b>
                            {{ departmentMeta.settings?.level1?.plural ? departmentMeta.settings?.level1?.plural : 'department'
                            }}<template v-if="departmentMeta.settings?.level == 2 && values.school != null">
                                and{{ departmentMeta.settings?.level2?.plural ? departmentMeta.settings?.level2?.plural : 'school' }} </template
                            >.
                        </b>
                    </p>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-outline-default" data-dismiss="modal" @click.prevent="closeAllModal()">No, Cancel</button>
                    <button class="btn btn-success" @click.prevent="submit">Yes, Confirm</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, nextTick, computed } from 'vue';
import { notify } from '@kyvg/vue3-notification';

const emit = defineEmits(['emptySelectedStaffs']);

const props = defineProps({
    staffsSelected: {
        type: Array,
        default: () => [],
    },
    departmentMeta: {
        type: Object,
        default: () => {},
    },
});

const modal = ref(null);
const values = ref({});

const confirmation = (v = {}, s = []) => {
    values.value = v;

    nextTick(() => {
        $(modal.value).modal('show');
    });
};

const staffsComputed = computed(() => {
    return props.staffsSelected.map((staff) => {
        return {
            userUuid: staff.uuid,
            level1DepartmentId: values.value.department.id,
            level2DepartmentId: values.value.school?.id,
        };
    });
});

const closeModal = () => {
    nextTick(() => {
        $(modal.value).modal('hide');
    });
};

const submit = () => {
    axios
        .post(`/departments/assign-user`, {
            teachers: staffsComputed.value,
        })
        .then(function (response) {
            closeModal();
            notify({
                group: 'form',
                type: 'success',
                title: 'Success',
                text: `Departments & Schools have been installed`,
            });

            Events.fire('teachers_listing_refresh');
            emit('emptySelectedStaffs');
        })
        .catch(function (errors) {
            notify({
                group: 'form',
                type: 'error',
                title: 'Error',
                text: 'Something went wrong, please try again later',
            });
        });
};

defineExpose({ confirmation });
</script>
